var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"header":"Donat"}},[_c('svg-donut',{staticClass:"w5",attrs:{"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }